/**
 * 后期需要改版，暂时先用这一版本
 */
interface IimgResize {
  (url: string, resizeWidth: number, resizeHeight?: number): string
}

const isSupportWebp = () => {
  // 如果走服务器渲染默认给webp ？
  // for ssr render
  // 临时处理，这里有个渲染的问题，需要试验好方案后再执行
  if (typeof window === 'undefined') return true

  return (
    typeof window !== 'undefined' &&
    document
      .createElement('canvas')
      .toDataURL('image/webp')
      .indexOf('data:image/webp') === 0
  )
}

const isSupportWebpStatic = isSupportWebp()

/**
 * 图片CDN压缩方法
 * @param url 路由地址
 * @param resizeWidth 适配的宽度
 * @param resizeHeight 适配的高度
 * @param forceWebp 是否渲染webp
 * @returns { string } 返回一个压缩后的CDN图片地址
 */
const imgResize: IimgResize = (
  url,
  resizeWidth,
  resizeHeight,
  forceWebp = true
) => {
  try {
    const baseStr = `${resizeWidth ? `w_${resizeWidth}` : ''}${
      resizeHeight ? `,h_${resizeHeight}` : ''
    }`
    const isGif = url.toLowerCase().endsWith('.gif')
    const s = isSupportWebpStatic && !isGif && forceWebp ? '/format,webp' : ''
    const hasQuery = /\?[\s\S]*/.exec(url)
    const query = hasQuery ? hasQuery[0] : ''
    if (!hasQuery) {
      return `${url}?x-oss-process=image${s}/resize,${baseStr}`
    }

    const hasOssQuery = query.includes('x-oss-process')
    if (!hasOssQuery) {
      return `${url}&x-oss-process=image${s}/resize,${baseStr}`
    }

    const hasResize = query.includes(`image${s}/resize`)
    if (hasResize) return url

    return url.replace(/(?:\?|&)x-oss-process=([^&]*)(?:&|$)/, function(
      ...args
    ) {
      if (!args[1]) {
        return `${args[0]}image${s}/resize,${baseStr}`
      }
      return args[0].replace(args[1], `image${s}/resize,${baseStr}`)
    })
  } catch (error) {
    return url
  }
}

export default imgResize
